
import DesktopMenu from "./DesktopMenu";
import MobileMenu from "./MobileMenu";

function Sidebar({
  sidebarOpen,
  setSidebarOpen,
  sidebarMobile,
  setSidebarMobile
}: {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  sidebarMobile: boolean;
  setSidebarMobile: React.Dispatch<React.SetStateAction<boolean>>;
}) {

  



  return (
    <>
      <DesktopMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen}/>
      <MobileMenu sidebarMobile={sidebarMobile} setSidebarMobile={setSidebarMobile}/>
    </>
  );
}

export default Sidebar;
